import { render, staticRenderFns } from "./SidePanelAdsGpt.vue?vue&type=template&id=c39298dc&scoped=true"
import script from "./SidePanelAdsGpt.vue?vue&type=script&lang=js"
export * from "./SidePanelAdsGpt.vue?vue&type=script&lang=js"
import style0 from "./SidePanelAdsGpt.vue?vue&type=style&index=0&id=c39298dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39298dc",
  null
  
)

export default component.exports